import * as AppConstants from "AppConstants";
import { authHeader } from "app/services/auth.header.service";

/**
 * Project Service - Project Management API calls
 */

// Project Management
export const fetchAllProjects = async () => {
    const response = await fetch(AppConstants.GET_ALL_PROJECTS_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const fetchProjectById = async (projectId) => {
    const url = AppConstants.GET_PROJECT_BY_ID_ENDPOINT.replace(AppConstants.PROJECT_ID_PLACEHOLDER, projectId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createProject = async (projectData) => {
    const response = await fetch(AppConstants.CREATE_PROJECT_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(projectData),
    });
    return response.json();
};

export const updateProject = async (projectId, projectData) => {
    const url = AppConstants.UPDATE_PROJECT_ENDPOINT.replace(AppConstants.PROJECT_ID_PLACEHOLDER, projectId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(projectData),
    });
    return response.json();
};

export const deleteProject = async (projectId) => {
    const url = AppConstants.DELETE_PROJECT_ENDPOINT.replace(AppConstants.PROJECT_ID_PLACEHOLDER, projectId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

export const fetchProjectHealth = async (projectId) => {
    const url = AppConstants.GET_PROJECT_HEALTH_ENDPOINT.replace(AppConstants.PROJECT_ID_PLACEHOLDER, projectId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

// Milestone Management
export const fetchProjectMilestones = async (projectId) => {
    const url = AppConstants.GET_PROJECT_MILESTONES_ENDPOINT.replace(AppConstants.PROJECT_ID_PLACEHOLDER, projectId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createMilestone = async (milestoneData) => {
    const response = await fetch(AppConstants.CREATE_MILESTONE_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(milestoneData),
    });
    return response.json();
};

export const updateMilestone = async (milestoneId, milestoneData) => {
    const url = AppConstants.UPDATE_MILESTONE_ENDPOINT.replace(AppConstants.MILESTONE_ID_PLACEHOLDER, milestoneId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(milestoneData),
    });
    return response.json();
};

export const deleteMilestone = async (milestoneId) => {
    const url = AppConstants.DELETE_MILESTONE_ENDPOINT.replace(AppConstants.MILESTONE_ID_PLACEHOLDER, milestoneId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

// Resource Allocation
export const fetchProjectResources = async (projectId) => {
    const url = AppConstants.GET_PROJECT_RESOURCES_ENDPOINT.replace(AppConstants.PROJECT_ID_PLACEHOLDER, projectId);
    const response = await fetch(url, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

export const createResource = async (resourceData) => {
    const response = await fetch(AppConstants.CREATE_RESOURCE_ENDPOINT, {
        method: "POST",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(resourceData),
    });
    return response.json();
};

export const updateResource = async (resourceId, resourceData) => {
    const url = AppConstants.UPDATE_RESOURCE_ENDPOINT.replace(AppConstants.RESOURCE_ID_PLACEHOLDER, resourceId);
    const response = await fetch(url, {
        method: "PUT",
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(resourceData),
    });
    return response.json();
};

export const deleteResource = async (resourceId) => {
    const url = AppConstants.DELETE_RESOURCE_ENDPOINT.replace(AppConstants.RESOURCE_ID_PLACEHOLDER, resourceId);
    const response = await fetch(url, {
        method: "DELETE",
        headers: authHeader(),
    });
    return response.ok;
};

// Fetch all milestones
export const fetchAllMilestones = async () => {
    const response = await fetch(AppConstants.GET_ALL_MILESTONES_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};

// Fetch all resources
export const fetchAllResources = async () => {
    const response = await fetch(AppConstants.GET_ALL_RESOURCES_ENDPOINT, {
        method: "GET",
        headers: authHeader(),
    });
    return response.json();
};
